<template>
  <div class="bg-white">
    <v-alert v-if="loading" color="white" height="58" variant="outlined" />
    <v-alert v-else-if="projectApprovers.length" type="success" variant="outlined">
      <div class="text-dark-grey">
        <b>Project Approver:</b> {{ projectApprovers }}
      </div>
    </v-alert>
    <v-alert v-else-if="project" type="error" variant="outlined">
      <div class="text-dark-grey">
        <b>No project approver:</b> Go to
        <nuxt-link :to="{ name: 'projects-id', params: { id: project.id } }">
          project page
        </nuxt-link>
        to set a project approver
      </div>
    </v-alert>
  </div>
</template>

<script setup lang="ts">
import type { Jobsite } from '@quotetome/materials-api'

export interface Props {
  approverType: string
  project?: Jobsite | null
}

const props = defineProps<Props>()

const loading = ref(false)
const team = ref<any[]>([])

const projectApprovers = computed(() => team.value.filter(entry => entry[props.approverType])
  .map(entry => `${entry.user.first_name} ${entry.user.last_name}`).join(', '))

const { $api, $error } = useNuxtApp()
const fetchTeam = async () => {
  loading.value = true
  try {
    team.value = await $api.v1.jobsites.team(props.project?.id as number)
  }
  catch (error) {
    $error.report(error)
  }
  loading.value = false
}

watchEffect(() => {
  if (props.project) {
    fetchTeam()
  }
})
</script>
